/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cart_EmptyInputs */

const en_cart_empty = /** @type {(inputs: Cart_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your cart is empty`)
};

const th_cart_empty = /** @type {(inputs: Cart_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ตะกร้าของคุณว่างเปล่า`)
};

const ja_cart_empty = /** @type {(inputs: Cart_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カートは空です`)
};

const fr_cart_empty = /** @type {(inputs: Cart_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre panier est vide`)
};

const es_cart_empty = /** @type {(inputs: Cart_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu carrito está vacío`)
};

const ru_cart_empty = /** @type {(inputs: Cart_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваша корзина пуста`)
};

const zh_cart_empty = /** @type {(inputs: Cart_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`购物车是空的`)
};

const vi_cart_empty = /** @type {(inputs: Cart_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giỏ hàng của bạn đang trống`)
};

/**
* | output |
* | --- |
* | "Your cart is empty" |
*
* @param {Cart_EmptyInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const cart_empty = /** @type {((inputs?: Cart_EmptyInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cart_EmptyInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_cart_empty(inputs)
	if (locale === "ja") return ja_cart_empty(inputs)
	if (locale === "fr") return fr_cart_empty(inputs)
	if (locale === "es") return es_cart_empty(inputs)
	if (locale === "ru") return ru_cart_empty(inputs)
	if (locale === "zh") return zh_cart_empty(inputs)
	if (locale === "vi") return vi_cart_empty(inputs)
	return en_cart_empty(inputs)
});